export default __webpack_public_path__ + "static/media/Sanitare.35e8196b.svg";